import { render, staticRenderFns } from "./BoletoDashboard.vue?vue&type=template&id=d8eb62c8&"
import script from "./BoletoDashboard.vue?vue&type=script&lang=js&"
export * from "./BoletoDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports